export default __webpack_public_path__ + "static/media/编组 27.c2ce8e33.png";